// Mock data for Wheel of Life app

export const reflectionQuestions = [
  'What patterns do I notice in my life balance?',
  'Which areas bring me the most joy and fulfillment?',
  'What areas feel most out of alignment right now?',
  'What is one small step I can take this week to improve my lowest-scoring domain?',
  'What strengths from my highest-scoring areas can I leverage in other domains?',
  'What support or resources do I need to create more balance?',
  'What would my life look like if all domains were at a 9 or 10?',
  'What am I willing to commit to changing in the next 30 days?'
];

export const defaultDomains = [
  { 
    id: 1, 
    name: 'Career & Vocation', 
    color: '#4CAF50', 
    score: 0,
    questions: [
      'Am I fulfilled and energized by the work I do?',
      'Do I feel my career aligns with my values and purpose?',
      'Am I growing professionally and learning new skills?'
    ]
  },
  { 
    id: 2, 
    name: 'Financial Well-Being', 
    color: '#8BC34A', 
    score: 0,
    questions: [
      'Do I feel secure and confident about my financial situation?',
      'Am I able to meet my financial goals and obligations?',
      'Do I have a plan for my financial future?'
    ]
  },
  { 
    id: 3, 
    name: 'Physical Health', 
    color: '#CDDC39', 
    score: 0,
    questions: [
      'Do I feel energetic and physically strong?',
      'Am I taking care of my body through exercise and nutrition?',
      'Do I get adequate rest and sleep?'
    ]
  },
  { 
    id: 4, 
    name: 'Emotional Well-Being', 
    color: '#FFC107', 
    score: 0,
    questions: [
      'Do I feel emotionally balanced and at peace?',
      'Am I able to manage stress and difficult emotions effectively?',
      'Do I practice self-compassion and emotional care?'
    ]
  },
  { 
    id: 5, 
    name: 'Family', 
    color: '#FF9800', 
    score: 0,
    questions: [
      'Do I feel connected and supported by my family?',
      'Am I investing quality time in my family relationships?',
      'Do I feel loved and appreciated within my family?'
    ]
  },
  { 
    id: 6, 
    name: 'Friends', 
    color: '#FF5722', 
    score: 0,
    questions: [
      'Do I have meaningful friendships that enrich my life?',
      'Am I spending enough time nurturing my friendships?',
      'Do I feel supported and understood by my friends?'
    ]
  },
  { 
    id: 7, 
    name: 'Relationships & Love', 
    color: '#E91E63', 
    score: 0,
    questions: [
      'Do I feel fulfilled in my romantic relationship?',
      'Am I giving and receiving love in healthy ways?',
      'Do I communicate openly and honestly with my partner?'
    ]
  },
  { 
    id: 8, 
    name: 'Community & Giving', 
    color: '#9C27B0', 
    score: 0,
    questions: [
      'Do I feel connected to my community?',
      'Am I contributing to causes that matter to me?',
      'Do I feel I\'m making a positive impact on others?'
    ]
  },
  { 
    id: 9, 
    name: 'Fun & Recreation', 
    color: '#673AB7', 
    score: 0,
    questions: [
      'Do I regularly engage in activities that bring me joy?',
      'Am I making time for hobbies and interests I love?',
      'Do I feel I have a good balance of work and play?'
    ]
  },
  { 
    id: 10, 
    name: 'Physical Environment', 
    color: '#3F51B5', 
    score: 0,
    questions: [
      'Do I feel comfortable and at peace in my living space?',
      'Is my environment organized and supportive of my wellbeing?',
      'Do I feel safe and secure in my surroundings?'
    ]
  },
  { 
    id: 11, 
    name: 'Personal Growth', 
    color: '#2196F3', 
    score: 0,
    questions: [
      'Am I actively learning and developing new skills?',
      'Do I feel I\'m becoming the person I want to be?',
      'Am I challenging myself and stepping out of my comfort zone?'
    ]
  },
  { 
    id: 12, 
    name: 'Spirituality', 
    color: '#00BCD4', 
    score: 0,
    questions: [
      'Do I feel connected to something greater than myself?',
      'Am I living in alignment with my spiritual beliefs and values?',
      'Do I take time for reflection, meditation, or spiritual practices?'
    ]
  }
];

export const mockUser = {
  id: '1',
  name: 'John Doe',
  email: 'john@example.com',
  isPremium: false
};

export const mockAssessments = [
  {
    id: '1',
    date: '2025-01-15',
    domains: defaultDomains.map(d => ({ ...d, score: Math.floor(Math.random() * 10) + 1 }))
  }
];

export const mockCoachingTools = [];

export const pricingPlans = [
  {
    id: 'monthly',
    name: 'Monthly',
    price: 9.99,
    interval: 'month',
    features: [
      'Self-coaching tools & resources',
      'Save unlimited assessments',
      'Progress Dashboard - Track your journey',
      'Deep dive into every domain',
      'AI-powered insights',
      'Personalized action plans upon request'
    ]
  },
  {
    id: 'yearly',
    name: 'Yearly',
    price: 97,
    interval: 'year',
    popular: true,
    savings: 'Save $22.88',
    features: [
      'Self-coaching tools & resources',
      'Save unlimited assessments',
      'Progress Dashboard - Track your journey',
      'Deep dive into every domain',
      'AI-powered insights',
      'Personalized action plans upon request',
      'Priority support',
      'Exclusive content'
    ]
  }
];
